export class SaleOwner {
  sellerId: number;
  ownerCode: string;
  auctionEventId: number;
  firstName: string;
  lastName: string;
  company: string;
  contractId: number;
  contractConfidential: boolean;
  // assets: Equip[];
}
